<script>
	import RecipeService from "../server/service/RecipeService";
	import PagedContent from "../components/PagedContent.svelte";
</script>

<style>
</style>

<h1>Recipes</h1>
<PagedContent service={RecipeService} route="/recipes/" />
